import get from 'lodash.get';

import { environments } from '../../../siteConfig';

const isTrackingEnabled = () =>
  get(window, 'config.environment', environments.development) !==
  environments.development;

export default isTrackingEnabled;
